/* esm.sh - applesauce-common@5.2.0/dist/operations/legacy-message */
export * from "/*applesauce-common@5.2.0/esnext/dist/operations/legacy-message.mjs";
